<ion-header>
  <div class="modal-header">
    <div class="modal-title">
      <h3 *ngIf="isNewTemplate">Create Template</h3>
      <h3 *ngIf="!isNewTemplate && !isCloning">Edit Template</h3>
      <h3 *ngIf="!isNewTemplate && isCloning">Create a Copy</h3>
    </div>
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button
          fill="clear"
          shape="round"
          class="close-button"
          (click)="dismiss()"
        >
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>
  <ion-card style="margin: 15px">
    <div>
      <ion-label>
        <strong>Name</strong>
      </ion-label>
      <ion-input
        #nameInput
        placeholder="e.g. Weekly Newsletter"
        [(ngModel)]="name"
        class="input-field"
        (keyup.enter)="save()"
      >
      </ion-input>
    </div>

    <div *ngIf="!authService.selectedProject && isNewTemplate">
      <ion-label>
        <strong>Project</strong>
      </ion-label>
      <ion-input
        readonly
        (click)="selectProject($event)"
        [value]="
          selectedProjectName ||
          (authService.isTenantAdmin ? 'All projects' : 'None')
        "
        class="input-field"
      ></ion-input>
    </div>
  </ion-card>
  <div style="padding: 0 15px 15px">
    <ion-button (click)="save()" size="block" [disabled]="isLoading">
      <span *ngIf="isNewTemplate">Create</span>
      <span *ngIf="!isNewTemplate">Save</span>
    </ion-button>
    <ion-button
      (click)="delete()"
      color="danger"
      fill="clear"
      *ngIf="!isNew && !isCloning && !isNewTemplate"
      size="block"
      [disabled]="isLoading"
    >
      Delete
    </ion-button>
  </div>
</ion-header>
